(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb88e"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb88e"] = parcelRequire;
}
parcelRequire.register("7meeL", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $55b5a1b0c0eb630f$export$6503ec6e8aabbaf; }, function (v) { return $55b5a1b0c0eb630f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $55b5a1b0c0eb630f$export$f7ad0328861e2f03; }, function (v) { return $55b5a1b0c0eb630f$export$f7ad0328861e2f03 = v; });
var $55b5a1b0c0eb630f$export$6503ec6e8aabbaf;
var $55b5a1b0c0eb630f$export$f7ad0328861e2f03;
"use strict";
var $55b5a1b0c0eb630f$var$mapping = {};
function $55b5a1b0c0eb630f$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$55b5a1b0c0eb630f$var$mapping[keys[i]] = pairs[keys[i]];
}
function $55b5a1b0c0eb630f$var$resolve(id) {
    var resolved = $55b5a1b0c0eb630f$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$55b5a1b0c0eb630f$export$6503ec6e8aabbaf = $55b5a1b0c0eb630f$var$register;
$55b5a1b0c0eb630f$export$f7ad0328861e2f03 = $55b5a1b0c0eb630f$var$resolve;

});

var $fffffdd7a7b57cfd$exports = {};

(parcelRequire("7meeL")).register(JSON.parse('{"ag0T7":"index.c8c5b47a.js","5ykGR":"Grocery.727953c1.js","4iFYt":"index.8c2c7016.css"}'));

})();
//# sourceMappingURL=index.5c892dbc.js.map
